<script>
import { mapState } from 'vuex'
import RamadanBadge from './RamadanBadge.vue'

export default {
  components: {
    RamadanBadge
  },
  computed: {
    ...mapState({
      tickets: state => state.ramadan.ramadanTicketsCount
    })
  }
}
</script>

<template>
  <div class="ramadan-balance">
    <span>{{ $t('ramadan.checkout.total') }}</span>
    <RamadanBadge :count="String(tickets)" position="start"/>
  </div>
</template>

<style lang="scss" scoped>
.ramadan-balance {
  display: flex;
  justify-content: space-between;
  margin-block: 12px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}
</style>
